import './App.css';
import Nav from './components/Nav';
import Banner from './components/Banner';
import About from './components/About';
import Suits  from './components/Suits';

function App() {
  return (
    <>
      <Nav/>
      <Banner/>
      <About/>
      <Suits/>
    </>
  );
}

export default App;
